<script>
import Logo from '@/assets/logo/WhiteTextLogo-Animated.svg';

export default {
  name: 'LogoAnimated',

  components: {
    Logo,
  },
};
</script>

<template>
  <div class="logo-animation">
    <transition name="bounce" appear>
      <Logo class="logo" />
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.logo-animation {
  height: 100%;
  width: 100%;
}

.logo {
  width: 100%;
  height: auto;
  fill: white;
  filter: $black-drop-shadow;
}

@keyframes twinkle {
  0%,
  100% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(10deg);
  }
}

.right-big,
.right-small1,
.right-small2,
.left-big,
.left-small {
  transform-box: fill-box;
  transform-origin: center;
  -ms-animation: none !important;
}

.right-big {
  animation: twinkle 2.1s ease-in-out infinite;
  animation-delay: 0.5s;
}

.right-small1 {
  animation: twinkle 1.5s ease-in-out infinite;
}

.right-small2 {
  animation: twinkle 2.1s ease-in-out infinite;
  animation-delay: 0.2s;
}

.left-big {
  animation: twinkle 2.7s ease-in-out infinite;
}

.left-small {
  animation: twinkle 2.1s ease-in-out infinite;
  animation-delay: 0.5s;
}

.bounce-enter-active {
  animation: bounce-in 0.9s ease-in-out;
}

@keyframes bounce-in {
  0% {
    transform: scale(0.98);
  }
  50% {
    transform: scale(1.01) rotate(0.5deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}
</style>
